import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pennyworld/island5-removebg.png")